module.exports = __webpack_public_path__ + "img/Passive_vs_Active_Strategies.e2cef3c5.jpg";